var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArms0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 181,
    viewBox: "0 0 211 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_725_49751)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8669 6.241C71.084 5.4244 72.702 5.41486 74.6252 5.91254C75.5617 18.3256 87.247 24.986 105.587 24.986C123.733 24.986 135.463 18.467 136.623 6.30527C137.777 5.70643 140.846 5.38483 142.115 6.65414C142.115 6.65737 142.115 6.66059 142.115 6.66382C150.611 9.44497 159.137 12.3773 166.466 14.8984C169.811 16.0487 172.906 17.1133 175.636 18.0389C191.479 23.4102 201.005 68.1353 204.669 99.0199C200.203 103.513 187.921 109.059 163.894 109.059C163.894 111.294 163.837 127.984 163.779 144.754L163.779 144.782L163.779 144.824C163.72 161.735 163.662 178.707 163.662 181H105.5H105.499H47.496C47.496 178.705 47.3841 161.815 47.2726 144.996L47.2726 144.99L47.2726 144.986C47.1621 128.311 47.0521 111.709 47.0521 109.472C23.0254 109.472 10.7958 103.513 6.33008 99.0199C9.99429 68.1353 19.5204 23.4102 35.3632 18.0389C38.0932 17.1134 41.1884 16.0487 44.5325 14.8985L44.5326 14.8985C52.1449 12.2802 61.047 9.21826 69.8671 6.34283C69.8669 6.30891 69.8669 6.27497 69.8669 6.241Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9238 20.8486C16.7063 32.3761 8.60101 71.2811 5.2749 99.0208C9.50505 103.705 23.0055 110.039 47.0911 110.094C46.4949 87.9577 46.3041 54.237 47.9668 51.2714L47.9833 51.2421C47.013 43.3839 40.6621 34.0318 35.1379 26.823C33.3194 24.45 31.4561 22.6885 29.9238 20.8486Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4051 119.723V120.263H47.427C47.4197 120.085 47.4124 119.905 47.4051 119.723Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.771 20.6211C194.271 31.3709 202.563 70.6401 205.889 98.3798C201.659 103.064 188.158 109.398 164.072 109.453C164.669 87.3167 164.86 53.5961 163.197 50.6304L163.18 50.6011C164.151 42.7429 170.501 33.3908 176.026 26.182C177.844 23.8091 179.239 22.4609 180.771 20.6211Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.758 119.082V119.622H163.737C163.744 119.444 163.751 119.264 163.758 119.082Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2321 17.4134C44.9221 14.0554 56.4614 9.89503 69.6946 5.86958C70.6853 5.55888 73.2424 4.9855 75.0311 5.86957C75.4416 13.2898 80.5376 18.927 87.1056 21.8127C78.5899 26.5884 58.8345 39.0725 47.9382 50.8031C46.2689 43.2551 36.3632 27.9233 29.6357 20.9753C31.3728 19.2272 33.2751 18.0916 35.2321 17.4134Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.778 17.4135C166.088 14.0555 154.549 9.89517 141.316 5.86972C140.449 5.56886 137.978 5.06487 135.979 5.86971C135.569 13.2899 130.473 18.9272 123.905 21.8128C132.42 26.5885 152.176 39.0726 163.072 50.8032C164.741 43.2552 174.647 27.9235 181.375 20.9754C179.637 19.2273 177.735 18.0917 175.778 17.4135Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1059 110.636C23.0587 110.636 9.47755 104.121 5.00799 99.5916C4.60095 97.5243 5.04196 93.4461 6.08755 91.2666C11.774 96.2857 28.926 100.636 46.8469 101.155L47.1059 110.636Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.872 109.928C188.114 109.928 201.221 104.909 205.727 100.38C206.548 98.7231 206.137 93.3379 204.905 91.2666C199.173 96.2857 182.349 100.726 164.283 101.245L163.872 109.928Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6791 5.68697C72.862 4.99739 69.4081 5.54707 68.2246 6.29923C68.2246 21.4723 83.665 31.6139 105.279 31.6139C126.893 31.6139 142.161 21.64 142.161 6.46696C140.914 5.21881 136.88 5.09879 135.483 5.59992C134.558 17.817 123.197 24.3702 105.526 24.3702C87.8965 24.3702 76.6439 17.847 75.6791 5.68697Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.87266,
    y1: 185.298,
    x2: 222.127,
    y2: -8.7015,
    stroke: "#D82626",
    strokeWidth: 15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_725_49751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 211,
    height: 181,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArms0);
export default __webpack_public_path__ + "static/media/Arms 0.0e2acb1444416934f753855d815396a9.svg";
export { ForwardRef as ReactComponent };